import { createSlice } from "@reduxjs/toolkit";

const layoutSlice = createSlice({
  name: "layout",
  initialState: [],
  reducers: {
    //this function is used to change the breadcrumb name when it is dynamic
    //it receives the path of the route (as it's exist in the routes array) and the new name
    //todo: remove nullable checks when breadcrumbs are implemented in all routes
    //added nullable checks to avoid breaking the app
    changeBreadcrumbName(state, action) {
      let breadcrumbName = null;

      if (action.payload?.breadcrumbName) {
        breadcrumbName = action.payload.breadcrumbName;
      }

      let exBreadcrumb = state.find((crumb) => crumb?.path === action.payload?.path);

      if (exBreadcrumb !== undefined) {
        exBreadcrumb.breadcrumbName = breadcrumbName;
      } else {
        state.push({ path: action.payload?.path, breadcrumbName });
      }
    },
  },
});

export const layoutActions = layoutSlice.actions;
export default layoutSlice.reducer;
